// Вход рабочего приложения: кэш запросов (TanStack Query), маршруты (TanStack Router), тосты.
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createQueryClient } from './app/query-client.ts';
import { createAppRouter } from './app/router.tsx';
import { AppToasts } from './app/toasts.tsx';
import './styles.css';

const queryClient = createQueryClient();
const router = createAppRouter(queryClient);

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppToasts>
          <RouterProvider router={router} />
        </AppToasts>
      </QueryClientProvider>
    </StrictMode>,
  );
}
